import { useState, useEffect, useRef } from "react";
import axios from "axios";

const HospitalVisitSelect = ({ searchParams, handleInputChange, setDesc }) => {
    const [emogList, setEmogList] = useState([]);

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                    params: {
                        grdc: searchParams.searchGrdc,
                        loca: searchParams.searchLoca
                    }
                });
                setEmogList(response.data.emogList || []);
            } catch (error) {
                console.error('초기 데이터 로딩 중 오류 발생:', error);
            }
        };
        fetchInitialData();
    }, []);

    const mounted = useRef(false);

    useEffect(() => {
        const fetchHospList = async () => {
            if (!mounted.current) {
                mounted.current = true;
            } else {
                try {
                    const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                        params: {
                            grdc: searchParams.searchGrdc === 'N' ? 'Y' : searchParams.searchGrdc === 'Y' ? 'N' : '',
                            loca: searchParams.searchLoca
                        }
                    });
                    setEmogList(response.data.emogList || []);
                } catch (error) {
                    console.error('병원 목록 로딩 중 오류 발생:', error);
                }
            }
        };
        fetchHospList();
    }, [searchParams.searchGrdc]);

    useEffect(() => {
        const desc = emogList.find((a) => a.emogcode === searchParams.searchEmog)?.emogdesc;
        setDesc(desc);
    }, [searchParams.searchEmog])

    return (
        <>
            <th>내원일자</th>
            <td>
                <input
                    type="date"
                    name="searchFromdate"
                    value={searchParams.searchFromdate}
                    onChange={handleInputChange}
                />
                &nbsp;~&nbsp;
                <input
                    type="date"
                    name="searchTodate"
                    value={searchParams.searchTodate}
                    onChange={handleInputChange}
                    min={searchParams.searchFromdate}
                />
            </td>
            <th>센터구분</th>
            <td>
                <select
                    name='searchGrdc'
                    className='w-full'
                    value={searchParams.searchGrdc}
                    onChange={handleInputChange}
                    disabled={localStorage.getItem("userAuth") === "J003"}
                >
                    <option value="">전체</option>
                    <option value="N">권역외상센터</option>
                    <option value="Y">외상수련기관</option>
                </select>
            </td>
            <th>기관명</th>
            <td>
                <select
                    name='searchEmog'
                    className='w-full'
                    value={searchParams.searchEmog}
                    onChange={handleInputChange}
                    disabled={localStorage.getItem("userAuth") === "J003"}
                >
                    <option value="">전체</option>
                    {emogList.map(hosp => (
                        <option key={hosp.emogcode} value={hosp.emogcode}>
                            {hosp.emogdesc}
                        </option>
                    ))}
                </select>
            </td>
        </>
    );
}

export default HospitalVisitSelect;